/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';

export const HOOK_EVENT_TYPE_FLOW = "flow";
export const HOOK_EVENT_TYPE_CACHE = "cache";

export const HOOK_TYPE_CRON = "cron";
export const HOOK_TYPE_ONE_TIME = "one-time";
export const HOOK_TYPE_EMAIL = "email";
export const HOOK_TYPE_MANUAL_BUTTON = "manual-button";
export const HOOK_TYPE_INVITATION_ACCEPT = "invitation-accept";
export const HOOK_TYPE_DESTROY = "destroy";
export const HOOK_TYPE_FORM = "form";

export default declareEntity({
    entity: "hooks",
    graphQL: "Hook",
    name: "HOOK",
    description: "Hooks",
    userEditable: false,
    dynamoPrefix: 'sys',
    storageType: 'central',
    fields: (types) => { return {
        id: {
            name: "HOOK ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            relativeTo: ["organisation"],
            visibility: (hook) => hook['eventType'] === HOOK_EVENT_TYPE_CACHE,
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['channels'],
            relativeTo: ["organisation"],
            visibility: (hook) => hook['eventType'] === HOOK_EVENT_TYPE_FLOW,
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
            visibility: (hook) => hook['eventType'] === HOOK_EVENT_TYPE_FLOW,
        },
        flowStepDef: {
            name: "Flow Step Definition",
            type: "relation",
            to: () => types['flowStepDefs'],
            relativeTo: ["flowDef"],
            visibility: (hook) => hook['eventType'] === HOOK_EVENT_TYPE_FLOW,
        },
        type: {
            name: "Type",
            type: "enum",
            defaultValue: HOOK_TYPE_CRON,
            values: {
                [HOOK_TYPE_CRON]: {
                    name: "CRON expression",
                },
                [HOOK_TYPE_ONE_TIME]: {
                    name: "One Time invocation",
                },
                [HOOK_TYPE_EMAIL]: {
                    name: "Email gateway",
                },
                [HOOK_TYPE_MANUAL_BUTTON]: {
                    name: "Manual button",
                },
                [HOOK_TYPE_FORM]: {
                    name: "Form",
                },
            },
        },
        showOnFlowDetail: {
            name: "Show in flow detail",
            type: "boolean",
            defaultValue: false,
            visibility: (hook) => hook['type'] === HOOK_TYPE_FORM,
        },
        showInFormMenu: {
            name: "Show in form menu",
            type: "boolean",
            defaultValue: false,
            visibility: (hook) => hook['type'] === HOOK_TYPE_FORM,
        },
        eventType: {
            name: "Event Type",
            type: "enum",
            defaultValue: HOOK_EVENT_TYPE_FLOW,
            values: {
                [HOOK_EVENT_TYPE_FLOW]: {
                    name: "Flow Invocation",
                },
                [HOOK_EVENT_TYPE_CACHE]: {
                    name: "Check caching",
                },
            },
        },
        typeType: {
            name: "Type Type",
            type: "enum",
        },
        nextInvoke: {
            name: "Next Invocation",
            type: "datetime",
            visibility: (hook) => hook['type'] === HOOK_TYPE_CRON || hook['type'] === HOOK_TYPE_ONE_TIME,
        },
        expression: {
            name: "CRON Expression",
            type: "string",
            defaultValue: "",
            visibility: (hook) => hook['type'] === HOOK_TYPE_CRON || hook['type'] === HOOK_TYPE_ONE_TIME,
        },
        email: {
            name: "Email",
            type: "string",
            defaultValue: "",
            visibility: (hook) => hook['type'] === HOOK_TYPE_EMAIL,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; }
});
